import type React from 'react';
import StarFilledIcon from './assets/star-filled.svg';
import StarOutlineIcon from './assets/star-outline.svg';
import styles from './index.module.scss';

export type StarRatingProps = {
  rating: number | null;
  onRatingChange: (rating: number) => void;
  disabled?: boolean;
};

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  disabled = false,
}) => {
  const handleClick = (value: number) => {
    if (!disabled) {
      onRatingChange(value);
    }
  };

  const displayRating = rating ?? 0;

  return (
    <div className={styles.starRating} role="radiogroup" aria-label="5段階評価">
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          type="button"
          onClick={() => handleClick(value)}
          disabled={disabled}
          role="radio"
          aria-checked={rating === value}
          aria-label={`5段階評価の${value}`}
        >
          <img
            src={value <= displayRating ? StarFilledIcon : StarOutlineIcon}
            alt=""
          />
        </button>
      ))}
    </div>
  );
};
